import React, { useState } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

import { useStyles } from './TechlinkMobileBurgerMenu_style'
import { Box } from '@material-ui/core'

import TechlinkMobileBurgerMenuContainer from '../TechlinkMobileBurgerMenuContainer/TechlinkMobileBurgerMenuContainer'
import MobileJobWallet from 'wrappers/PageWrapper/components/MenuNavigation/MobileNavigation/MobileJobWallet/MobileJobWallet'
import TechlinkMobileWalletCard from '../TechlinkMobileWalletCard/TechlinkMobileWalletCard'

const TechlinkMobileBurgerMenu = (props) => {
    const { intl } = props
    const classes = useStyles()
    const [jobTypeSelection, setJobTypeSelection] = useState(null)
    const { formatMessage } = intl

    return (
        <TechlinkMobileBurgerMenuContainer {...props}
            jobTypeSelection={jobTypeSelection}
            setJobTypeSelection={setJobTypeSelection}
        >
            <Box className={classes.burgerMenuContainer}>
                <Box className={classes.linksContainer}>
                    <TechlinkMobileWalletCard
                        url={`techlink/${formatMessage({ id: 'routes.student-jobs' })}`}
                        name={<FormattedMessage id='page_footer_navbar_data.student_job_button' />}
                        page='student-jobs'
                    />
                    <TechlinkMobileWalletCard
                        url={`techlink/${formatMessage({ id: 'routes.internships' })}`}
                        name={<FormattedMessage id='page_footer_navbar_data.internship_button' />}
                        page='internships'
                    />
                    <TechlinkMobileWalletCard
                        url={`techlink/${formatMessage({ id: 'routes.first-jobs' })}`}
                        name={<FormattedMessage id='page_footer_navbar_data.first_job_button' />}
                        page='first-jobs'
                    />
                    <TechlinkMobileWalletCard
                        url={`techlink/${formatMessage({ id: 'routes.companies' })}`}
                        name={<FormattedMessage id='page_footer_navbar_data.companies_burger' />}
                        page='companies'
                    />
                </Box>
            </Box>
        </TechlinkMobileBurgerMenuContainer>
    )
}

export default injectIntl(TechlinkMobileBurgerMenu)
